/**
 * The hotel the URL names, or the user's default one when the URL names none. An empty object when the
 * user's hotels are not loaded yet, or when the URL names a hotel the user does not have.
 */
export function findSelectedHotel(hotels: any[] | null | undefined, hotelId: unknown): any {
  let hotel: any = {};
  if (hotels && hotels.length > 0) {
    hotel = hotels.find((i) => i.default_hotel);
    if (hotel == null || typeof hotel == "undefined") {
      hotel = hotels[0];
    }
    if (hotelId) {
      hotel = hotels.find((i) => i.id == hotelId) ?? {};
    }
  }
  return hotel;
}
